import { useState, useEffect } from "react";
import RaceWidget from "../../../../../../components/RaceWidget";
import {
  getVicePresidentList,
  getRegions,
} from "../../../../../api/ph-api";

export const getStaticProps = async () => {
  let vPresidential = await getVicePresidentList();
  let regionList = await getRegions();

  vPresidential.results.forEach((candidate) => {
    candidate.selected = true;
    candidate.voteCount = "0";
    candidate.votePercentage = 0;
    switch (candidate.last_name.toLowerCase()) {
      case "pangilinan":
        candidate.color = "rgba(252, 106, 223, 1)";
        candidate.legend = "rect";
        break;
      case "duterte":
        candidate.color = "rgba(192, 36, 2, 1)";
        candidate.legend = "rectRot";
        break;
      case "atienza":
        candidate.color = "rgba(57, 198, 240, 1)";
        candidate.legend = "circle";
        break;
      case "ong":
        candidate.color = "rgba(64, 118, 255, 1)";
        candidate.legend = "rectRot";
        break;
      case "bello":
        candidate.color = "rgba(242, 106, 90, 1)";
        candidate.legend = "rect";
        break;
      case "sotto":
        candidate.color = "rgba(183, 125, 222, 1)";
        candidate.legend = "circle";
        break;
      case "serapio":
        candidate.color = "rgba(72, 167, 104, 1)";
        candidate.legend = "rect";
        break;
      case "david":
        candidate.color = "rgba(202, 185, 36, 1)";
        candidate.legend = "triangle";
        break;
      case "lopez":
        candidate.color = "rgba(92, 161, 144, 1)";
        candidate.legend = "rectRot";
        break;
      default:
        candidate.color = "rgba(0, 0, 0, 1)";
        candidate.legend = "circle";
        break;
    }
  });

  if (!vPresidential || !regionList) {
    return {
      props: { vPresidential, regionList },
      revalidate: 5
    };
  }

  return {
    props: { vPresidential, regionList },
  };
};

const EmbedVicePresidentPartialResults = ({ vPresidential, regionList }) => {
  const [url, setUrl] = useState("");
  
  useEffect(() => {
    setUrl(`${window.location.origin}/elections/2022/races/president-vice-president/overseas-absentee-voting-results`);
  }, []);

  return (
    <RaceWidget
      view="overseas-absentee-voting-results"
      withCollapse={false}
      candidatesList={vPresidential?.results}
      regionList={regionList?.results}
      contestName="vice presidential race"
      raceName="VICE PRESIDENT PHILIPPINES"
      description="The winner will become the 15th vice president of the Philippines, to serve for six years, starting noon of June 30, 2022. "
      readMoreLink="https://www.rappler.com/nation/elections/president-vp-philippines-powers-duties/"
      quote="#PHVoteResults: 2022 PH election overseas voting results for president and vp  #PHVote #WeDecide"
      urlPath="/elections/2022/candidates/"
      url={url}
      marginTop="marginTop"
      isEmbed="true"
    />
  );
}

export default EmbedVicePresidentPartialResults;
